<button  *ngIf="(contentText?.length || 0) > minLength" #ellipsisButton id="seeMore"
    (click)="showDialog()"   [attr.aria-label]="'iaa.general.showMore' | translate" class="show-more-btn">
    <i class="pi pi-ellipsis-h"></i>
  </button>
  <p-dialog *ngIf="isVisible" ariaLabelTarget
  [targetSelector]="'div[role=dialog]'"
  [ariaLabelText]="headerText"
   [showCloseIcon]="true" [dir]="'rtl'" [dismissableMask]="true" class="dialog"
    maskStyleClass="dialog-mask" [modal]="true" [(visible)]="isVisible" [closable]="false"
    [style]="{ width: '50vw', height: '300px' }" (onShow)="onDialogShow()" (onHide)="onDialogHide()" aria-labelledby="see-more-header">
      <ng-template pTemplate="header">
        <div [ngClass]="{'header-container':true, 'en':(currentLanguage | async)==='en'}">
          <h2 class="see-more-header" id="see-more-header">{{headerText}} </h2>
          <button #closeBtn class="p-dialog-header-icon p-dialog-header-close p-link p-button p-component" [attr.aria-label]="'iaa.aria.close' | translate " (click)="hideDialog()" (keydown.enter)="hideDialog()">
            <i class="pi pi-times"></i>
          </button>
        </div>
        </ng-template>
      <p [dir]="descriptionDirection"> {{ contentText }} </p>
    </p-dialog>